<template>
    <div id="prestataires">
        <div class="app-container" v-show="!$global.loading">
            <div class="d-flex justify-content-between mt-3 mb-3">
                <div class="d-flex ">
                    <div class="page-title mr-5">
                        Prestataires <span v-if="providers.length">({{ providers.length }})</span>
                    </div>
                </div>
            </div>

            <div class="mt-2 mb-3">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="providers"
                        :loading="loading"
                        no-data-text="Aucun prestataires"
                        class="elevation-1"
                        :footer-props="{
                                itemsPerPageAllText: 'Tous',
                                itemsPerPageText: 'Prestataire par page',
                                itemsPerPageOptions: [1000]
                            }">
                        <template v-slot:item.aura_form="{ item }">
                            <div v-if="item.aura_form.status !== null">
                                {{ getStatusLabel(item.aura_form.status) }}
                                <span v-if="item.aura_form.answered_at !== null">
                                    <v-btn color="primary" icon :to="'/receptive/answer/' + item.aura_form.token">
                                        <v-icon v-if="item.aura_form.status === 'ANSWERED'">email</v-icon>
                                        <v-icon v-if="item.aura_form.status === 'UPDATED_AGENCY' ||
                                                      item.aura_form.status === 'FINISHED'">remove_red_eye</v-icon>
                                    </v-btn>
                                </span>
                            </div>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-menu bottom v-if="item.aura_form !== null &&
                                                (item.aura_form.status === 'SENT' ||
                                                 item.aura_form.status === 'EMAIL_ERROR' ||
                                                 item.aura_form.status === 'EMAIL_NOT_FOUND')">
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>

                                <v-list>
                                    <v-list-item @click="resendForm(item.aura_form)"
                                                 v-if="item.aura_form !== null &&
                                                 (item.aura_form.status === 'SENT' ||
                                                 item.aura_form.status === 'EMAIL_ERROR' ||
                                                 item.aura_form.status === 'EMAIL_NOT_FOUND')">
                                        <v-list-item-title>
                                            <v-icon color="primary">send</v-icon> Renvoyer le formulaire
                                        </v-list-item-title>
                                    </v-list-item>

                                    <v-list-item v-if="item.aura_form.token !== null &&
                                                       item.aura_form.status !== 'UPDATED_AGENCY' &&
                                                       item.aura_form.status !== 'FINISHED' &&
                                                       item.aura_form.status !== 'ANSWERED'"
                                                 target="_blank"
                                                 :to="'/aura/' + item.aura_form.token">
                                        <v-list-item-title>
                                            <v-icon color="primary">remove_red_eye</v-icon> Voir le formulaire
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AuraProvider",
    data() {
        return {
            providers: [],
            loading: false,
            headers: [
                {
                    text: 'Nom',
                    value: 'last_version.name'
                },
                {
                    text: 'Catégorie',
                    value: 'last_version.category.label'
                },
                {
                    text: 'Commune',
                    value: 'last_version.localisation.commune.name'
                },
                {
                    text: 'Destinataire',
                    value: 'aura_form.destinataire'
                },
                {
                    text: 'Formulaire',
                    value: 'aura_form'
                },
                {
                    text: 'Actions',
                    value: 'actions'
                }
            ]
        }
    },
    methods: {
        getProviders() {
            this.loading = true

            this.$http.get('auth/aura/providers').then(res => {
                this.providers = res.body.data.providers

                this.loading = false
            })
        },
        getStatusLabel(code) {
            let label = null

            switch (code) {
                case 'SENT':
                    label = 'Envoyé'
                    break
                case 'ANSWERED':
                    label = 'Réponse reçue'
                    break
                case 'UPDATED_AGENCY':
                    label = 'Fiche agence à jour'
                    break
                case 'FINISHED':
                    label = 'Fiche et séjours à jour'
                    break
                case 'EMAIL_NOT_FOUND':
                    label = 'Email non trouvé'
                    break
                case 'EMAIL_ERROR':
                    label = 'Erreur lors de l\'envoi de l\'email'
                    break
                case 'DRAFT':
                    label = 'Brouillon'
                    break
                default:
                    label = null
            }

            return label
        },
        resendForm(auraForm) {
            let token = auraForm.token

            this.$global.loading = true

            this.$http.get('auth/aura/resend/' + token).then(res => {
                this.$global.loading = false

                this.getProviders()
            })
        }
    },
    created() {
        this.getProviders()
    }
}
</script>